export default function HeroSection() {
  return (
    <section className="relative w-full h-[420px] md:h-[600px] overflow-hidden">
      <img
        src="https://readdy.ai/api/search-image?query=Dramatic%20dark%20atmosphere%20with%20warm%20golden%20spotlights%20piercing%20through%20smoke%2C%20mysterious%20cinematic%20stage%20lighting%2C%20abstract%20geometric%20shapes%20floating%20in%20darkness%2C%20elegant%20theater%20curtain%20textures%2C%20luxurious%20dark%20aesthetic%20with%20golden%20and%20warm%20amber%20accents%2C%20professional%20entertainment%20industry%20backdrop%2C%20sophisticated%20noir%20vibe&width=1800&height=900&seq=hero-bg-2026&orientation=landscape"
        alt="51黑料网 - 全网最新爆料"
        className="absolute inset-0 w-full h-full object-cover object-top"
      />
      <div className="absolute inset-0 bg-gradient-to-b from-black/50 via-black/35 to-black/60"></div>

      <div className="relative z-10 w-full h-full flex flex-col items-center justify-center px-4 md:px-6">
        <div className="text-center max-w-3xl">
          <div className="inline-flex items-center gap-2 px-4 py-1.5 rounded-full bg-accent-500/20 border border-accent-500/30 mb-6">
            <span className="w-1.5 h-1.5 rounded-full bg-accent-500 animate-pulse"></span>
            <span className="text-xs font-medium text-accent-300">实时更新中</span>
          </div>
          <h1 className="text-3xl md:text-5xl lg:text-6xl font-heading font-bold text-background-50 leading-tight mb-4">
            全网最新黑料
            <span className="text-accent-500"> 第一时间爆料</span>
          </h1>
          <p className="text-sm md:text-base text-background-50/70 max-w-xl mx-auto mb-8 leading-relaxed">
            聚合今日黑料、每日大赛与一区二区热门内容，实时追踪娱乐圈最新动态，让你不错过任何一个瓜
          </p>
          <div className="flex flex-col sm:flex-row items-center justify-center gap-3">
            <a
              href="#trending"
              className="px-8 py-3 bg-accent-500 text-foreground-950 font-semibold rounded-full text-sm hover:bg-accent-400 transition-all whitespace-nowrap cursor-pointer"
            >
              立即吃瓜
              <i className="ri-arrow-right-line ml-2"></i>
            </a>
            <a
              href="#daily-contest"
              className="px-8 py-3 bg-white/10 backdrop-blur-sm text-background-50 font-medium rounded-full text-sm hover:bg-white/20 transition-all whitespace-nowrap cursor-pointer border border-white/20"
            >
              每日大赛
            </a>
          </div>
        </div>
      </div>

      <div className="absolute bottom-6 left-1/2 -translate-x-1/2 z-10 animate-bounce">
        <i className="ri-arrow-down-s-line text-background-50/60 text-2xl"></i>
      </div>
    </section>
  );
}